var _path, _path2, _path3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgMastercard(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 100 62"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FF5F00",
    d: "M36.5 6.7h27v48.6h-27z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#EB001B",
    d: "M38.2 31c0-9.9 4.6-18.6 11.8-24.3C44.8 2.6 38.2.1 30.9.1 13.8.1 0 13.9 0 31s13.8 30.9 30.9 30.9c7.2 0 13.8-2.5 19.1-6.6-7.2-5.6-11.8-14.4-11.8-24.3z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#F79E1B",
    d: "M100 31c0 17.1-13.8 30.9-30.9 30.9-7.2 0-13.8-2.5-19.1-6.6 7.2-5.7 11.8-14.4 11.8-24.3S57.2 12.4 50 6.7C55.2 2.6 61.8.1 69.1.1 86.2.1 100 14 100 31z"
  })));
}

export default SvgMastercard;